import React from "react";
import { Row, Col } from "antd";
import { Package } from "lucide-react";

function WhyChooseUs() {
  const features = [
    {
      title: "Premium Print Quality",
      description:
        "Experience vibrant, long-lasting prints that stay sharp wash after wash. We use advanced printing technology and top-grade materials to ensure every design looks flawless.",
    },
    {
      title: "Easy Customization",
      description:
        "Our intuitive online design tool makes creating your custom T-shirt effortless. Upload your artwork, add text, and preview your design in real time — no design skills required!",
    },
    {
      title: "Fast & Reliable Delivery",
      description:
        "From small orders to bulk prints, we pride ourselves on quick turnaround times and dependable shipping, so your custom apparel arrives exactly when you need it.",
    },
    {
      title: "Local Experts, Global Reach",
      description:
        "Proudly based in California, we serve both local businesses and international clients — combining local craftsmanship with global quality standards.",
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-white text-dev-choose">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <h4 className="font-custom text-base md:text-lg lg:text-[22px] text-gray-600 mb-2">
            Why Choose Us
          </h4>
          <h2 className="font-custom text-2xl md:text-3xl lg:text-4xl xl:text-[40px] font-bold text-gray-900">
            Why Choose Us
          </h2>
        </div>

        {/* Features Grid */}
        <Row gutter={[16, 24]} justify="center">
          {features.map((feature, index) => (
            <Col key={index} xs={24} sm={12} md={12} lg={6}>
              <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 md:p-6 h-full hover:shadow-xl hover:border-[#6cc5bf] transition-all duration-300 text-center group">
                {/* Icon */}
                <div className="flex justify-center mb-4 md:mb-5">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#e6f7f5] rounded-full group-hover:bg-[#6cc5bf] transition-colors duration-300">
                    <Package 
                      size={32} 
                      className="text-[#6cc5bf] group-hover:text-white transition-colors duration-300 w-7 h-7 md:w-8 md:h-8" 
                    />
                  </div>
                </div>

                {/* Title */}
                <h3 className="font-custom font-semibold text-base md:text-lg lg:text-xl mb-3 md:mb-4 text-gray-900">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm md:text-base leading-relaxed font-custom">
                  {feature.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}

export default WhyChooseUs;